import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import React, { useContext, useState } from 'react';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import whatsAppCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"
import styles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss"
import { useSearchParams } from 'react-router-dom';
// import { createWebhookPayload, functionParameters, functionResponse } from './webHookPopup';
import GlobalPopUp from '../../../../../utility/globalPopUp';
import CreateVariablePopup from '../dataCollections/createVariablePopup';
import GlobalDeletePopup from '../../../../../utility/globalDeletePopup/globalDeletePopup';
import { customVariableDataInterface, functionParameterData, functionResponseData } from '../../../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import agent from '../../../../../../services/api';
import MemoizedRow from './memoizedRow';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import EditResponseVarPathPopup from './editResponseVarPathPopup';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface AssignVariablesTablePropsGeneric {
    tableData: functionParameterData[] | functionResponseData[],
    payload: any[] | any[],
    setPayload: React.Dispatch<React.SetStateAction<any>>;
    onChangeOfField: (value: customVariableDataInterface | null, ind: number, key: string) => void;
    onChangeOfFallbackValue: (value: string, ind: number, keyName: string) => void;
    onChangeOfFieldVariableType?: (value: any, ind: number, keyName: string) => void,
    fieldKeyName: string,
    flagVariableAssignment: boolean
}
const AssignVariablesTable = (props: AssignVariablesTablePropsGeneric) => {
    const { tableData, payload, onChangeOfField, onChangeOfFallbackValue,
        setPayload, onChangeOfFieldVariableType, fieldKeyName,
        flagVariableAssignment
    } = props;
    
    const setFlagDataCollectionPopup = useFlowBuilderStore((state) => state.setFlagDataCollectionPopup)
    const flagDataCollectionPopup = useFlowBuilderStore((state) => state.flagDataCollectionPopup)
    const setFlagUpdateFieldData = useFlowBuilderStore((state) => state.setFlagUpdateFieldData)
    const existingCustomVariablePayload = useFlowBuilderStore((state) => state.existingCustomVariablePayload)
    const flagDeleteFieldData = useFlowBuilderStore((state) => state.flagDeleteFieldData)
    const setFlagDeleteData = useFlowBuilderStore((state) => state.setFlagDeleteData)
    const GetCustomVariableListApi = useFlowBuilderStore((state) => state.GetCustomVariableListApi)
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams()
    let workflow_id = searchParams.get("workflow_id")
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');

    const [flagEditResVarPathPopup, setFlagEditResVarPathPopup] = useState<boolean>(false);
    const [selectedResPayload, setSelectedResPayload] = useState<any | null>(null);


    const handleDeleteField = async () => {
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: true } });
        const res = await agent.deleteChatbotCustomVariable.delete(existingCustomVariablePayload.chatbot_custom_variable_config_id)
        if (res.status) {
            showSuccess("Field Deleted Successfully")
            await GetCustomVariableListApi(workflow_id || "")
        }
        else {
            handleError(res);
        }
        setFlagLoading((prevState) => { return { ...prevState, flagRoundLoader: false } });
    }

    const sortTableData = (tableData: functionParameterData[] | functionResponseData[]) => {
        if (isFunctionParameterTableData(tableData)) {
            return tableData.sort((a, b) => Number(a.function_parameter_data_id) - Number(b.function_parameter_data_id));
        } else {
            return tableData.sort((a, b) => Number(a.function_response_data_id) - Number(b.function_response_data_id));
        }
    }

    const isFunctionParameterTableData = (data: functionParameterData[] | functionResponseData[]): data is functionParameterData[] => {
        return data.length > 0 && 'function_parameter_data_id' in data[0];
    }


    return (
        <>
            <TableContainer className={`${globalStyles.boxSizingBorderBox} ${globalStyles.maxWidthFull} ${globalStyles.fullwidth} ${globalStyles.overflowAuto} ${styles.assignVariableTableMaxHeight}`}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}></TableCell>
                            {flagVariableAssignment && 
                                <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Variable Type</TableCell>
                            }
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Custom/Meta Variable</TableCell>
                            <TableCell className={whatsAppCampaignStyles.tableHeadingFontStyle} sx={{ backgroundColor: "#F4F4F4 !important" }}>Fallback Value</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <>
                            {sortTableData(tableData).map((parameter: functionParameterData | functionResponseData, ind: number) => {
                                return (
                                    <MemoizedRow payload={payload} ind={ind} parameter={parameter} onChangeOfField={onChangeOfField} onChangeOfFallbackValue={onChangeOfFallbackValue} setFlagEditResVarPathPopup={setFlagEditResVarPathPopup} setSelectedResPayload={setSelectedResPayload} onChangeOfFieldVariableType={onChangeOfFieldVariableType} fieldKeyName={fieldKeyName} flagVariableAssignment={flagVariableAssignment} />
                                );
                            })}
                        </>
                    </TableBody>
                </Table>
            </TableContainer>

            {flagDataCollectionPopup &&
                <GlobalPopUp
                    open={flagDataCollectionPopup}
                    onClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                    handleClose={() => { setFlagDataCollectionPopup(false); setFlagUpdateFieldData(false) }}
                >
                    <CreateVariablePopup />
                </GlobalPopUp>
            }
            {flagDeleteFieldData &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure want to delete ${existingCustomVariablePayload.chatbot_custom_variable_name} field`}
                    open={flagDeleteFieldData}
                    onClose={() => { setFlagDeleteData(false) }}
                    onDelete={() => {
                        handleDeleteField()
                        setFlagDeleteData(false)
                    }}
                />
            }
            {flagEditResVarPathPopup &&
                <GlobalPopUp
                    open={flagEditResVarPathPopup}
                    onClose={() => { setFlagEditResVarPathPopup(false); setSelectedResPayload(null); }}
                    handleClose={() => { setFlagEditResVarPathPopup(false); setSelectedResPayload(null); }}
                    paperMinWidth={flagSmallScreen ? "310px" : "700px"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "750px"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                >
                    <EditResponseVarPathPopup
                        selectedResPayload={selectedResPayload as any}
                        setSelectedResPayload={setSelectedResPayload}
                        setFlagEditResVarPathPopup={setFlagEditResVarPathPopup}
                        setPayload={setPayload} 
                        fieldKeyName={fieldKeyName}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default React.memo(AssignVariablesTable) as typeof AssignVariablesTable
